<template>
    <div class="side" :class="isCollapse ?'side-collapse':''">
        <div class="head-left-logo" @click="yxyun()" title="返回站神平台">
            <i class="icon i-nsy1-1"></i>
        </div>
        <div class="meun-txt" @click="hreftwo" title="返回控制台">
            <span>自助</span>MTP
            <span>- 中文版</span>
        </div>
        <!-- <el-scrollbar class="hidden-scrollbar"> -->
        <div class="meun-min">
            <el-menu background-color="#152348" :default-active="activeMenu" text-color="#fff" active-text-color="#4358AB" collapse-transition menu-trigger="hover" :unique-opened="false" :collapse="isCollapse">
                <SideMenuItem v-for="route in routesList" :key="route.path" :item="route" :base-path="route.path" />
            </el-menu>
        </div>
        <div class="menu-toggle" @click="changeFn()">
            <i v-if="!isCollapse" class="iconfont icon-bianzu1"></i>
            <i v-else class="iconfont icon-bianzu1-copy"></i>
        </div>
        <!-- </el-scrollbar> -->
    </div>
</template>

<script>
import SiteNavItem from './SiteNavItem'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'
import MemberApi from '@/api/member.api'
import userApi from "@/api/user.api";
export default {
    name: 'siteNavBar',
    data () {
        return {
			isOpen: '',
			routesList: []
        }
    },
    components: {
        SideMenuItem: SiteNavItem
    },
    computed: {
        ...mapState(['isCollapse']),
        ...mapGetters('user', ['userInfo']),
        activeMenu () {
            const route = this.$route
            const { meta, path } = route
            return path
        },
		aiContent () {
			return localStorage.getItem('AI_CONTENT') && localStorage.getItem('AI_CONTENT') === 'true'
		},
        siteContent () {
			return localStorage.getItem('SITE_CONTENT') && localStorage.getItem('SITE_CONTENT') === 'true'
		}
    },
    methods: {
		...mapActions('user', ['getUserAuthorityFn']),
		routes () {
			// let userJsonStr =
			//   let userJsonStr = JSON.parse(sessionStorage.getItem('Lavrock-User'))
			let userJsonStr = this.userInfo
			let navFilter = ['/order', '/contract']
			let routes = this.$router.options.routes
			let sideRoutes = []
			sideRoutes = routes.filter(routeItem => {
				if (userJsonStr.sysOrigin === '渠道代理') {
					return routeItem.meta && routeItem.meta.sideNav && !navFilter.includes(routeItem.path)
				} else {
					if (routeItem.path === '/liveList' || routeItem.path === '/videoList' || routeItem.path === '/ai' || routeItem.outLink === true) routeItem.meta.hidden = !(this.isOpen === 'Y')
                    // 判断账号是否有站群权限
                    if (routeItem.path === '/siteNetwork') routeItem.meta.hidden = !this.siteContent
					return routeItem.meta && routeItem.meta.sideNav
				}
			})
			return sideRoutes
		},
		// 判断左侧导航栏权限
		getLeftNavAuthority (){
			let params = {}
			this.getUserAuthorityFn(params).then(res => {
				if (res.data.isSuccess){
					this.isOpen = res.data.data
				}
				if (this.aiContent) this.isOpen = 'Y'
				this.routesList = this.routes()
			})
		},

        ...mapMutations(['SET_IS_COLLAPSE']),
        changeFn () {
            this.SET_IS_COLLAPSE(!this.isCollapse)
        },
        ...mapActions('member', ['authorizeNewNSY']),
        async yxyun () {

            const parmas = {
                route: 'home',
                type: '0',
            }
            const data = await this.authorizeNewNSY(parmas)
            if (data.isSuccess) {
                window.open(data.nswUrl)
            } else {
                this.$message.error('授权登陆失败')
            }
            // let { data } = await MemberApi.authorizeNswYun({ clientId: 'nswyun-client' })
            // if (data.isSuccess) {
            // 	let url = `${data.data.nswyunUrl}`
            // 	window.open(url)
            // } else {
            // 	this.$message.error('授权登陆失败')
            // }
        },
        hreftwo () {
            this.$router.push({ path: '/tool/console' })
        },
		async getEnterpriseFn() {
            localStorage.setItem('AI_CONTENT', false)
            localStorage.setItem('SITE_CONTENT', false)
			// AI白名单
			const enterpriseInfo = await userApi.enterpriseInfo()
			if (enterpriseInfo.data.isSuccess && enterpriseInfo.data.data && enterpriseInfo.data.data.param) {
				localStorage.setItem('AI_CONTENT', enterpriseInfo.data.data.param.includes('AI'))
				localStorage.setItem('SITE_CONTENT', enterpriseInfo.data.data.clusterWebsites === '1')
			}
            // else {
			// 	localStorage.setItem('AI_CONTENT', false)
            //     localStorage.setItem('SITE_CONTENT', false)
			// }
		}
    },
	async created() {
		await this.getEnterpriseFn()
		this.getLeftNavAuthority()
	}
}
</script>

<style lang="scss" scoped>
.side {
    width: 160px;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #152348;
    z-index: 999;
    overflow: hidden;
    -webkit-transition: width 0.28s;
    transition: width 0.28s;
    &.side-collapse {
        -webkit-transition: width 0.28s;
        transition: width 0.28s;
        width: 56px;
    }
}
.head-left-logo {
    text-align: center;
    cursor: pointer;
}
.meun-txt {
    font-size: 12px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    border-top: 1px solid #27314e;
    border-bottom: 1px solid #27314e;
    cursor: pointer;
}
.meun-min {
    width: 190px;
    height: calc(100% - 150px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-color: transparent transparent;
    scrollbar-track-color: transparent;
    -ms-scrollbar-track-color: transparent;
    /*修改滚动条样式*/
    &::-webkit-scrollbar {
        width: 0;
        height: 0;
        /**/
    }
}
.menu-toggle {
    position: absolute;
    left: 50%;
    bottom: 10px;
    margin-left: -18px;
    font-size: 0;
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
    i {
        display: block;
        width: 17px;
        height: 17px;
        font-size: 14px;
        color: #fff;
    }
    &:hover {
        background: #303040;
    }
}
</style>
